<template>

  <b-col>
    <slot name="p-1"></slot>
    <hr class="style-hr"/>

    <div class="p-2-transition">
      <slot name="p-2"></slot>
    </div>
  </b-col>


</template>

<script>
export default {
  name: "S515",

};
</script>
<style>

</style>

<style scoped>
.style-hr {
  border-top: 4px solid var(--secondary);
  width: 140px;
  margin-right: 10px;
}

.p-2-transition > * {
  transition: all ease-in-out 0.3s;
  margin-right: 0;
}

.p-2-transition:hover > * {
  margin-right: 18px;
  transition: all ease-in-out 0.3s;
}

</style>

